import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SendInsurancePayload, SendedLaSegundaResponse } from './brasil-generic-quote-email.types';

type Config = { type: 'swissre' };

export async function brasilGenericQuoteEmailService({ body }: SendInsurancePayload, config: Config) {
  const ENDPOINT_MAP = {
    swissre: ENDPOINT.INSURANCE_SWISS_RE,
  };

  const { response, data } = await BACKEND.post<SendedLaSegundaResponse>(ENDPOINT_MAP[config.type], {
    body,
  });

  return {
    response,
    summary: data,
  };
}
